var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var HierarchyConfig_1;
import { ToolType } from '@symon-ai/wisepipe-base-pipe';
import { Column } from '@symon-ai/wisepipe-common-data';
import { JSON, JsonDiscriminatorValue, JsonSchema, OnDeserialized } from '@symon-ai/wisepipe-serialize';
import { EdgeElement } from './edgeElement';
import './hierarchyColumn'; // force import for JsonSchema
import { HierarchyColumn } from './hierarchyColumn';
import { HierarchyV2Config } from './hierarchyV2Config';
import { ToolCategories } from './toolCategories';
import { ToolConfig } from './toolConfig';
import { ToolConfigInfo } from './toolConfigInfo';
import { ToolScopeBuilder } from './toolScopeBuilder';
import { ToolValidationResult } from './validation/toolValidationResult';
import { validateSourceWithDetail } from './validation/validateHelper';
const schema = {
    $id: 'urn:wisepipe-common-pipe:HierarchyConfig',
    type: 'object',
    oneOf: [
        {
            properties: {
                columns: {
                    type: 'array',
                    items: { $ref: 'urn:wisepipe-common-pipe:HierarchyColumn' },
                    uniqueItems: true,
                    minItems: 1,
                    maxItems: 10
                },
                rootName: { type: 'string', maxLength: 20 }
            }
        },
        {
            properties: {
                columns: {
                    type: 'array',
                    items: { type: 'string' },
                    uniqueItems: true,
                    minItems: 1,
                    maxItems: 10
                },
                rootName: { type: 'string', maxLength: 20 }
            }
        }
    ],
    required: ['columns']
};
let HierarchyConfig = HierarchyConfig_1 = class HierarchyConfig extends ToolConfig {
    constructor(columns, rootName, customFormats) {
        super(ToolType.HIERARCHY, customFormats);
        if (columns && columns.length > 0 && typeof columns[0] === 'string') {
            this.columns = columns.map((col) => new HierarchyColumn(col));
        }
        else {
            this.columns = columns;
        }
        this.rootName = rootName;
        JSON.validate(this, HierarchyConfig_1);
    }
    toHierarchyColumns() {
        if (this.columns && this.columns.length > 0 && typeof this.columns[0] === 'string') {
            this.columns = this.columns.map((col) => new HierarchyColumn(col));
        }
    }
    // eslint-disable-next-line class-methods-use-this
    get in() {
        return HierarchyConfig_1.in;
    }
    // eslint-disable-next-line class-methods-use-this
    get out() {
        return HierarchyConfig_1.out;
    }
    // eslint-disable-next-line class-methods-use-this
    get ins() {
        return HierarchyConfig_1.ins;
    }
    // eslint-disable-next-line class-methods-use-this
    get outs() {
        return HierarchyConfig_1.outs;
    }
    static get in() {
        return HierarchyConfig_1.ins[0];
    }
    static get out() {
        return HierarchyConfig_1.outs[0];
    }
    static get ins() {
        return ['default'];
    }
    static get outs() {
        return ['default'];
    }
    static get info() {
        return new ToolConfigInfo(ToolType.HIERARCHY.split('_')
            .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
            .join(' '), [ToolCategories.ORGANIZE], this.ins, this.outs, ['hierarchy'], true);
    }
    getOutput(iConfigHelper, ins) {
        const tsb = new ToolScopeBuilder(ins);
        const source = ins.schemas.at(this.in);
        if (source) {
            const exp = tsb.export(this.out);
            const dependents = this.columns.map((a) => this.getDependent(exp, this.in, a.key));
            const alias = ['Key', 'Name', 'Parent Key', 'Level'];
            for (const a of alias) {
                exp.makeNew(new Column(a, 'string'), dependents, true);
            }
            exp.initializeColumnFormats().setColumnFormats(this.customFormats);
        }
        return tsb.build();
    }
    isValidForCalc(iConfigHelper, scope) {
        const toolValidationResult = this.getToolValidationResult(iConfigHelper, scope);
        return toolValidationResult.validationState;
    }
    getToolValidationResult(iConfigHelper, scope) {
        const source = scope.schemas.at(this.in);
        if (!source) {
            return ToolValidationResult.getMissingSourceColumnsResult();
        }
        const col = new Set(this.columns.map((col) => col.key));
        const sourceValidationResult = validateSourceWithDetail(source, col, []);
        return ToolValidationResult.getResultFromSourceValidation(sourceValidationResult);
    }
    updateToolConfig(config) {
        return new HierarchyV2Config(config.columns, config.rootName, config.customFormats);
    }
    updateIns(edge, edgeIDs) {
        return new EdgeElement(edge.elementID, edge.srcElementID, edge.srcPort, edge.tarElementID, edge.tarPort);
    }
    updateOuts(edge) {
        return new EdgeElement(edge.elementID, edge.srcElementID, edge.srcPort, edge.tarElementID, edge.tarPort);
    }
};
__decorate([
    OnDeserialized()
], HierarchyConfig.prototype, "toHierarchyColumns", null);
HierarchyConfig = HierarchyConfig_1 = __decorate([
    JsonSchema(schema),
    JsonDiscriminatorValue(ToolType.HIERARCHY)
], HierarchyConfig);
export { HierarchyConfig };
//# sourceMappingURL=hierarchyConfig.js.map